module.exports = __webpack_public_path__ + "img/9788994612362.9116ab17.jpg";